export default __webpack_public_path__ + "static/media/WhiteOtrosDocuments.2d0f418f.svg";